
// agriflow/activities/static/js/module/ActivitiesUpdate.js

import FetchHandler from '../../../../assets/js/assets/FetchHandler'
import AlertHandler from '../../../../assets/js/modules/alertHandler';

import { Modal } from 'bootstrap';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';

export default class ActivitiesUpdate{
    constructor(buttonClass){
        this.buttonClass = buttonClass;
        this.modalEl = document.querySelector('#activitiesModal');
        this.modal = new Modal(this.modalEl, { backdrop: 'static' });
        this.bindButtonEvents();
        this.addCloseEventListeners();
        this.initModalEvents();
    }

    initModalEvents() {
        this.modalEl.addEventListener('shown.bs.modal', () => {
          this.modalEl.removeAttribute('aria-hidden');
        });
    }


    addCloseEventListeners() {
        document.querySelectorAll('.close-modal-button-activities').forEach(button => {
            button.addEventListener('click', () => {
                this.modal.hide()
            });
        });
    }

    async bindButtonEvents() {
        document.body.addEventListener('click', async (event) => {
            const btn = event.target.closest(this.buttonClass);
            if (!btn) return;
            try {
                const response = await FetchHandler.getData(btn.dataset.url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                const data = await response.json();

                const { html, object_id } = data;
                
                this.modalEl.querySelector('.modal-body').innerHTML = ''
                this.modalEl.querySelector('.modal-body').innerHTML = html || '<p>Kein Inhalt verfügbar</p>';
                this.initForm(object_id);
                this.modal.show();
                

            } catch (error) {
                console.error(error);
            }
        });
    }


    initForm(id) {
        const form = this.modalEl.querySelector('#activities_form');
        const dzArea = this.modalEl.querySelector('#activity-dropzone');
        const token = dzArea.querySelector('[name="csrfmiddlewaretoken"]').value;
        const fileInp = dzArea.querySelector('input[type="file"]');

        dzArea.classList.remove('d-none');
        Dropzone.autoDiscover = false;

        if (!dzArea.dropzone) {

            this.dropzone = new Dropzone(dzArea, {
                url: `/activities/upload-attachment/${id}/`, 
                autoProcessQueue: true, 
                addRemoveLinks: true,
                dictRemoveFile: '✖',
                previewsContainer: dzArea,
                paramName: 'file', 
                headers: { 'X-CSRFToken': token },
                acceptedFiles: '.jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx',
                dictDefaultMessage: 'Bild hierher ziehen oder klicken',
                init: function() {
                    const dz = this;

                    dz.on('success', (file, response) => {
                        if (typeof window.reloadActivitiesList === 'function') {
                            window.reloadActivitiesList();
                        } 
                    });

                    const syncInput = () => {
                    const dt = new DataTransfer();
                    dz.files
                        .filter(f => f instanceof File)
                        .forEach(f => dt.items.add(f));
                    fileInp.files = dt.files;
                    };
                    dz.on('addedfile', syncInput);
                    dz.on('removedfile', async file => {
                    if (file.serverId) {
                        const response = await fetch(`/activities/upload-attachment/${file.serverId}/`, {
                        method: 'DELETE',
                        headers: { 'X-CSRFToken': token }
                        });
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        const data = await response.json();
                        if (data.success) {
                            AlertHandler.showAlert(data.message, 'success');
                        }                  
                    }
                    syncInput();
                    });
                    fetch(`/activities/upload-attachment/${id}/`, { headers: { 'X-CSRFToken': token } })
                    .then(r => r.json())
                    .then(files => {
                        files.forEach(f => {
                        const mock = { name: f.name, size: f.size, serverId: f.id };
                        dz.files.push(mock);
                        dz.emit('addedfile', mock);
                        if (/\.(jpe?g|png|gif)$/i.test(f.name)) {
                            dz.emit('thumbnail', mock, f.url);
                        } else {
                            mock.previewElement.classList.add('dz-no-files');
                        }
                        dz.emit('complete', mock);
                        });
                        syncInput();
                    })
                    .catch(e => console.error(e));
                }
            });
        }

    }



}